
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import CheckedIcon from "@/components/icons/status/CheckedIcon.vue";
  import ReloadIcon from "@/components/icons/status/ReloadIcon.vue";
  import AlertIcon from "@/components/icons/status/AlertIcon.vue";
  import ActivityHoursUnconfirmedAlert from "@/components/projects/activities/ActivityHoursUnconfirmedAlert.vue";

  @Component({
    components: {
      ActivityHoursUnconfirmedAlert,
      AlertIcon,
      ReloadIcon,
      CheckedIcon,
      CardItemTitle,
    },
  })
  export default class ProjectStatus extends Vue {
    @Prop({ type: Boolean, default: false }) readonly completed!: boolean;
    @Prop({ type: Boolean, default: false }) readonly alert!: boolean;

    get alertShown(): boolean {
      return this.alert && !this.completed;
    }

    get title(): string {
      if (this.completed) {
        return "Completed";
      }

      return "In progress";
    }

  }
